import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';

import { FreemiumChainGuard } from './components/FreemiumChainGuard';
import { ProductsPageGuard } from './components/ProductsPageGuard';
import { useChainPageStyles } from './useChainPageStyles';

const ChainPage = loadable(
  async () => {
    const module = await import('./ChainPage');

    return module.ChainPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

export const ChainPageContainer = () => {
  const { classes } = useChainPageStyles();

  return (
    <Page classes={classes}>
      <ProductsPageGuard>
        <NoSSRGuard fallback={<ChainPage />}>
          <FreemiumChainGuard>
            <GuardAccountPermission
              fallback={<OverlaySpinner />}
              permission={AccountPermission.ChainItem}
              shouldHideAlert
              shouldRedirect
            >
              <ChainPage />
            </GuardAccountPermission>
          </FreemiumChainGuard>
        </NoSSRGuard>
      </ProductsPageGuard>
    </Page>
  );
};
